import { defineComponent as k, openBlock as n, createElementBlock as a, createElementVNode as t, normalizeClass as l, unref as o, toDisplayString as d, createCommentVNode as c, Fragment as g, createTextVNode as m, renderList as f, normalizeStyle as h, createBlock as w, renderSlot as C } from "vue";
import { useLandingAnimation as z } from "./index127.js";
import L from "./index60.js";
const j = {
  key: 0,
  class: "absolute inset-0 z-0"
}, T = ["src"], H = {
  key: 1,
  class: "absolute inset-0 z-0",
  style: { background: "linear-gradient(135deg, #1a1a1a 0%, #242424 50%, #2e2e2e 100%)" }
}, S = { class: "grid grid-cols-1 items-center gap-12 lg:grid-cols-2" }, V = { class: "flex flex-col gap-6" }, B = ["innerHTML"], I = ["innerHTML"], M = ["href", "onClick"], N = {
  key: 0,
  class: "h-5 w-5 shrink-0",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, D = {
  key: 1,
  class: "flex h-3.5 w-3.5 items-center justify-center text-[10px]",
  style: { color: "var(--landing-primary)" }
}, E = { class: "text-xs font-medium text-gray-300" }, P = {
  class: "relative",
  style: { animation: "landing-hero-float 3s ease-in-out infinite" }
}, F = /* @__PURE__ */ k({
  __name: "LandingHero",
  props: {
    overline: {},
    title: {},
    description: {},
    ctas: { default: () => [] },
    badges: { default: () => [] },
    bgImage: {},
    primary: { default: "var(--base-colors-primary-primary800)" },
    topPadding: { default: "0px" }
  },
  setup(r) {
    const u = r, { el: p, isVisible: i } = z(), x = {
      paddingTop: u.topPadding,
      "--landing-primary": u.primary,
      "--landing-dark": "var(--base-colors-neutral-neutral750)",
      "--landing-dark-900": "var(--base-colors-neutral-neutral800)",
      "--landing-dark-600": "var(--base-colors-neutral-neutral700)"
    };
    function b(y, s) {
      if (!s.startsWith("#")) return;
      y.preventDefault();
      const e = document.querySelector(s);
      e && e.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    return (y, s) => (n(), a("section", {
      "data-landing-hero": "",
      class: "relative flex min-h-screen items-center overflow-hidden bg-[#0f0f0f]",
      style: x
    }, [
      r.bgImage ? (n(), a("div", j, [
        t("img", {
          src: r.bgImage,
          alt: "",
          class: "h-full w-full object-cover object-center"
        }, null, 8, T),
        s[0] || (s[0] = t("div", {
          class: "absolute inset-0",
          style: { background: `linear-gradient(
            to right,
            rgba(15, 15, 15, 0.9) 0%,
            rgba(26, 26, 26, 0.75) 50%,
            rgba(36, 36, 36, 0.6) 100%
          )` }
        }, null, -1)),
        s[1] || (s[1] = t("div", {
          class: "absolute inset-0",
          style: { background: `linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.3) 0%,
            transparent 50%,
            rgba(0, 0, 0, 0.2) 100%
          )` }
        }, null, -1))
      ])) : (n(), a("div", H)),
      t("div", {
        ref_key: "el",
        ref: p,
        class: "relative z-10 mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8"
      }, [
        t("div", S, [
          t("div", V, [
            r.overline ? (n(), a("span", {
              key: 0,
              class: l(["inline-block text-xs font-semibold uppercase tracking-widest transition-all duration-500", o(i) ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"]),
              style: { color: "var(--landing-primary)" }
            }, d(r.overline), 3)) : c("", !0),
            t("h1", {
              class: l(["text-5xl font-extrabold leading-tight tracking-tight text-white md:text-6xl lg:text-7xl", o(i) ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"]),
              style: { transition: `opacity 0.5s ease,
                transform 0.5s ease`, "transition-delay": "150ms" },
              innerHTML: r.title
            }, null, 10, B),
            t("p", {
              class: l(["max-w-lg text-base leading-relaxed text-gray-300 md:text-lg", o(i) ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"]),
              style: { transition: `opacity 0.5s ease,
                transform 0.5s ease`, "transition-delay": "300ms" }
            }, [
              r.description.includes("<br />") ? (n(), a("span", {
                key: 0,
                innerHTML: r.description
              }, null, 8, I)) : (n(), a(g, { key: 1 }, [
                m(d(r.description), 1)
              ], 64))
            ], 2),
            r.ctas.length ? (n(), a("div", {
              key: 1,
              class: l(o(i) ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"),
              style: { transition: `opacity 0.5s ease,
                transform 0.5s ease`, "transition-delay": "450ms" }
            }, [
              (n(!0), a(g, null, f(r.ctas, (e) => (n(), a("a", {
                key: e.href,
                href: e.href,
                class: l([
                  "landing-hero-cta inline-flex items-center gap-2 rounded-xl px-8 text-lg font-semibold transition-all duration-200",
                  e.variant === "secondary" ? "landing-hero-cta--secondary" : "landing-hero-cta--primary"
                ]),
                style: h(
                  e.variant === "secondary" ? "background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2)" : "background: var(--landing-primary)"
                ),
                onClick: (v) => b(v, e.href)
              }, [
                m(d(e.label) + " ", 1),
                e.variant !== "secondary" ? (n(), a("svg", N, [...s[2] || (s[2] = [
                  t("line", {
                    x1: "5",
                    y1: "12",
                    x2: "19",
                    y2: "12"
                  }, null, -1),
                  t("polyline", { points: "12 5 19 12 12 19" }, null, -1)
                ])])) : c("", !0)
              ], 14, M))), 128))
            ], 2)) : c("", !0),
            r.badges.length ? (n(), a("div", {
              key: 2,
              class: l(["mt-2 flex flex-wrap gap-3", o(i) ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"]),
              style: { transition: `opacity 0.5s ease,
                transform 0.5s ease`, "transition-delay": "600ms" }
            }, [
              (n(!0), a(g, null, f(r.badges, (e) => (n(), a("div", {
                key: e.label,
                class: "flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1.5"
              }, [
                e.icon && (e.icon === "watch" || e.icon === "shield" || e.icon === "globe") ? (n(), w(L, {
                  key: 0,
                  name: e.icon,
                  size: 14,
                  color: "var(--landing-primary)",
                  className: "shrink-0"
                }, null, 8, ["name"])) : e.icon ? (n(), a("span", D, d(e.icon), 1)) : c("", !0),
                t("span", E, d(e.label), 1)
              ]))), 128))
            ], 2)) : c("", !0)
          ]),
          t("div", {
            class: l(["flex justify-center lg:justify-end", o(i) ? "opacity-100" : "opacity-0"]),
            style: { transition: "opacity 0.6s ease", "transition-delay": "200ms", transform: "scale(1)" }
          }, [
            t("div", P, [
              C(y.$slots, "visual", {}, () => [
                s[3] || (s[3] = t("div", {
                  class: "relative w-64 overflow-hidden rounded-3xl border shadow-xl md:w-72 lg:w-80",
                  style: { background: "var(--landing-dark-900)", "border-color": "var(--landing-dark-600)", "aspect-ratio": "9/19" }
                }, [
                  t("div", { class: "flex h-full items-center justify-center text-gray-500" }),
                  t("div", { class: "absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/20" })
                ], -1))
              ], !0),
              s[4] || (s[4] = t("div", {
                class: "absolute -inset-4 -z-10 rounded-3xl blur-2xl",
                style: { background: "color-mix(in srgb, var(--landing-primary) 5%, transparent)" }
              }, null, -1))
            ])
          ], 2)
        ])
      ], 512)
    ]));
  }
});
export {
  F as default
};
